import React from 'react';
import ReactDOM from 'react-dom';
import Gallery from 'blueimp-gallery';
import Swiper from 'react-id-swiper';

import 'swiper/css/swiper.css'
import 'blueimp-gallery/css/blueimp-gallery.min.css';


/**
 * Component for displaying the images in a blueimp lightbox image gallery.
 *
 * Expects the property `images` to be a list of images to be displayed. Each element in the list should have two keys:
 *  - `fullUrl` - The URL for the full size image.
 *  - `thumb` - A dictionary that should contain the following keys:
 *      `thumb.src` - The URL for the thumbnail image.
 *      `thumb.width` - The width of the thumbnail image.
 *      `thumb.height` - The height of the thumbnail image.
 *      `thumb.alt` - The alternative text for the image.
 */
export default class ImageGallery extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        let controls = document.getElementById('blueimp-gallery');
        if (!controls) {
            document.body.insertAdjacentHTML(
                'beforeend',
                '<div id="blueimp-gallery" class="blueimp-gallery blueimp-gallery-controls">' +
                '<div class="slides"></div>' +
                '<h3 class="title"></h3>' +
                '<p class="description"></p>' +
                '<a class="prev">‹</a>' +
                '<a class="next">›</a>' +
                '<a class="close">×</a>' +
                '<a class="play-pause"></a>' +
                '<ol class="indicator"></ol>' +
                '</div>'
            );
        }

        this.registerGallery(ReactDOM.findDOMNode(this));
    }

    registerGallery(container) {
        container.onclick = function (event) {
            event = event || window.event;
            let target = event.target || event.srcElement;
            if (target.tagName == 'A' || target.tagName == 'IMG') {
                let link = target.src ? target.parentNode : target;
                let options = {
                    index: link,
                    event: event,
                    onslide: function (index, slide) {
                        let text = this.list[index].getAttribute('data-description'),
                            node = this.container.find('.description');
                        node.empty();
                        if (text) {
                            node[0].appendChild(document.createTextNode(text));
                        }
                    }
                };
                let links = this.getElementsByTagName('a');
                Gallery(links, options);
            }
        };
    }

    render() {
        const swiperParams = {
            scrollbar: '.swiper-scrollbar',
            scrollbarDraggable: true,
            scrollbarHide: false,
            slidesPerView: 'auto',
            spaceBetween: 3,
            grabCursor: true,
            nextButton: '.button.next',
            prevButton: '.button.prev',
            buttonDisabledClass: 'disabled',
        };

        return (
            <div className="image-gallery">
                <Swiper {...swiperParams}>
                    {this.props.images.map((image, index) => {
                        return (
                            <a key={index} href={image.fullUrl} data-description={image.caption} style={{width: image.thumb.width + 'px'}}>
                                <img src={image.thumb.src} width={image.thumb.width} height={image.thumb.height}
                                     alt={image.thumb.alt}/>
                            </a>
                        );
                    })}
                </Swiper>
            </div>
        );
    }

}
